import { eventsConst } from '../consts';

export function events(state = {}, action) {
    switch (action.type) {
        case eventsConst.EVENTS_REQUEST:
            return { ...state, getting: true };
        case eventsConst.EVENTS_SUCCESS:
            return {
                ...state,
                getting: false,
                events: action.events.filter((event) => !event.default),
                currentEvent: action.events.find((event) => event.default),
            };
        case eventsConst.EVENTS_FAILURE:
            return {
                ...state,
                getting: false,
                errors: action.errors,
            };
        default:
            return state;
    }
}
